var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTechnicalSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.078.285l.159.042c.568.146.74.769.37 1.133L20.23 5.775l1.037 3.55 3.597 1.021 4.377-4.315a.68.68 0 011.132.303c.77 2.916.006 5.975-2.15 8.102-2.435 2.4-6.046 3.106-9.191 1.894L5.87 29.3a3.448 3.448 0 01-4.857 0 3.336 3.336 0 010-4.791l13.15-12.98a8.372 8.372 0 011.92-9.065A8.588 8.588 0 0122.692.018c.413.027.723.093 1.386.267zM22.604 1.35a7.225 7.225 0 00-5.563 2.058 7.052 7.052 0 00-1.556 7.782c.165.395.073.851-.233 1.152L1.97 25.452a2.015 2.015 0 000 2.904c.823.812 2.12.812 2.943 0l13.292-13.097c.307-.304.77-.396 1.171-.23 2.684 1.101 5.801.524 7.89-1.536 1.514-1.494 2.211-3.54 2.014-5.615l-3.576 3.527c-.28.276-.691.378-1.06.267l-3.9-1.108a1.065 1.065 0 01-.735-.724l-1.12-3.837a1.046 1.046 0 01.268-1.056l3.63-3.58a3.101 3.101 0 00-.184-.017z",
    fill: "#000"
  })));
}

SvgTechnicalSupport.displayName = 'TechnicalSupport';
export default SvgTechnicalSupport;